import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { roleGuard } from './core/auth/role.guard';

/** Título de pestaña de las pantallas del panel de administración. */
const PANEL_TITLE = 'Unity · Panel de administración';

export const routes: Routes = [
  {
    path: 'login',
    title: PANEL_TITLE,
    loadComponent: () =>
      import('./features/auth/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'reset-password',
    title: PANEL_TITLE,
    loadComponent: () =>
      import('./features/auth/reset-password/reset-password.component').then(
        (m) => m.ResetPasswordComponent,
      ),
  },
  {
    path: 'forgot-password',
    title: PANEL_TITLE,
    loadComponent: () =>
      import('./features/auth/forgot-password/forgot-password.component').then(
        (m) => m.ForgotPasswordComponent,
      ),
  },
  {
    path: 'not-found',
    title: 'UNITY · Página no encontrada',
    loadComponent: () =>
      import('./shared/components/not-found/not-found.component').then((m) => m.NotFoundComponent),
  },

  // Portada pública: presentación de la app móvil (no requiere sesión).
  // Debe ir antes que la zona privada, que también cuelga de la ruta vacía.
  {
    path: '',
    pathMatch: 'full',
    title: 'UNITY · La app para Policía Nacional y Guardia Civil',
    loadComponent: () =>
      import('./features/landing/landing.component').then((m) => m.LandingComponent),
  },

  // Zona privada: layout con barra lateral y las tres secciones del panel.
  // Su inicio es /orden-general; la raíz queda para la portada.
  {
    path: '',
    title: PANEL_TITLE,
    loadComponent: () => import('./layout/shell/shell.component').then((m) => m.ShellComponent),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['admin', 'editor'] },
    children: [
      {
        path: 'orden-general',
        loadComponent: () =>
          import('./features/orden-general/orden-general.component').then(
            (m) => m.OrdenGeneralComponent,
          ),
        children: [
          {
            path: '',
            pathMatch: 'full',
            data: { animation: 'categorias' },
            loadComponent: () =>
              import('./features/orden-general/categoria-list/categoria-list.component').then(
                (m) => m.CategoriaListComponent,
              ),
          },
          {
            path: ':categoriaId/tematicas',
            data: { animation: 'tematicas' },
            loadComponent: () =>
              import('./features/orden-general/tematica-list/tematica-list.component').then(
                (m) => m.TematicaListComponent,
              ),
          },
          {
            path: ':categoriaId/tematicas/:tematicaId/publicacion',
            data: { animation: 'publicaciones' },
            loadComponent: () =>
              import('./features/orden-general/publicacion-view/publicacion-view.component').then(
                (m) => m.PublicacionViewComponent,
              ),
          },
        ],
      },
      {
        path: 'estadisticas',
        canActivate: [roleGuard],
        data: { roles: ['admin'] },
        loadComponent: () =>
          import('./features/estadisticas/estadisticas.component').then(
            (m) => m.EstadisticasComponent,
          ),
      },
      {
        path: 'reportes',
        canActivate: [roleGuard],
        data: { roles: ['admin'] },
        loadComponent: () =>
          import('./features/reportes/reportes.component').then((m) => m.ReportesComponent),
      },
      // Compatibilidad con los enlaces antiguos bajo /home
      { path: 'home', redirectTo: 'orden-general', pathMatch: 'full' },
      { path: 'home/:seccion', redirectTo: ':seccion' },
    ],
  },

  { path: '**', redirectTo: 'not-found' },
];
